import { useEffect, useRef, useState } from 'react'
import {
  Menu,
  X,
  ChevronDown,
  ArrowUpRight,
  ChevronRight,
  Phone,
  Mail,
  Globe,
  Linkedin,
  Facebook,
  Twitter
} from 'lucide-react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import logo from '../assets/logo/logo.png' // make sure this path is correct

const services = [
  // { name: 'LTL', path: '/services/ltl' },
  // { name: 'PTL', path: '/services/ptl' },
  // { name: 'FTL', path: '/services/ftl' },
  // { name: '3PL', path: '/services/3pl' },
  // { name: 'CL', path: '/services/cl' },
  { name: 'Surface Express', path: '/services/surface-express' },
  { name: 'Express Delivery', path: '/services/express-delivery' },
  { name: 'Cold Chain', path: '/services/cold-chain' },
  { name: 'Rail Cargo', path: '/services/rail-cargo' },
  { name: 'Contract Logistics', path: '/services/contract-logistics' },
  { name: 'Air Freight', path: '/services/air-freight-forwarding' },
  {
    name: 'Supply Chain Management',
    path: '/services/supply-chain-management'
  },
  { name: 'Last-Mile Delivery', path: '/services/last-mile-delivery' },
  { name: 'International Shipping', path: '/services/international' },
  { name: 'Warehousing', path: '/services/warehousing' }
]

const join_us = [
  { name: 'Careers', path: '/join-us/career' },
  { name: 'Client', path: '/join-us/client-registration' },
  { name: 'Franchise', path: '/join-us/franchise' }
]

const navigation = [
  // { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about-us' },
  { name: 'Services', path: '/services' },
  { name: 'Join Us', path: '/join-us' },
  { name: 'Contact', path: '/contact-us' }
]

export default function Header () {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [servicesDropdown, setServicesDropdown] = useState(false)
  const [joinUsDropdown, setJoinUsDropdown] = useState(false)

  const [activeDropdown, setActiveDropdown] = useState(null)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setMobileMenuOpen(false)
    setServicesDropdown(false)
    setJoinUsDropdown(false)
    setActiveDropdown(null)
  }, [location.pathname])

  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div className='bg-[#211f57] text-sm text-white font-medium'>
        <div className='max-w-7xl mx-auto px-4 flex justify-between items-center h-10'>
          <div className='flex gap-4 items-center'>
            <span className='flex items-center gap-1'>
              <Phone className='w-4 h-4' />
              <a href='tel:+919876543210' className='hover:underline text-sm'>
                +91 82373 23531
              </a>
            </span>

            <span className='hidden md:flex items-center gap-1'>
              <Mail className='w-4 h-4' />
              <a
                href='mailto:info@sinfiniteexpress.com'
                className='hover:underline text-sm'
              >
                info@sinfiniteexpress.com
              </a>
            </span>
          </div>
          <div className='flex gap-4 items-center'>
            <span className='hidden md:flex items-center gap-1'>
              <Globe className='w-4 h-4' /> Global Support
            </span>
            <div className='flex space-x-3'>
              <a
                href='https://www.facebook.com/people/S-Infinite-Express/61578114767602/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Facebook className='w-4 h-4 hover:text-blue-600 cursor-pointer' />
              </a>
              <a
                href='https://x.com/SInfinite01'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Twitter className='w-4 h-4 hover:text-blue-400 cursor-pointer' />
              </a>
              <a
                href='https://in.linkedin.com/company/s-infinite-express'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Linkedin className='w-4 h-4 hover:text-blue-800 cursor-pointer' />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className='sticky top-0 z-[100]'>
        {/* <header className='sticky top-0 z-50 border-b border-gray-100 bg-white/95 shadow-sm backdrop-blur-md'> */}
        <header className='relative z-50 border-b border-gray-100 bg-white/95 shadow-sm backdrop-blur-md'>
          {/* MAIN NAVBAR */}
          <div className='mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-2 sm:px-6 lg:px-8'>
            {/* LOGO */}
            <Link
              to='/'
              className='flex shrink-0 items-center'
              onClick={() => setMobileMenuOpen(false)}
            >
              <img
                src={logo}
                alt='S Infinite Express'
                className='h-12 w-auto object-contain sm:h-14 lg:h-16'
              />
            </Link>

            <div className='ml-auto flex items-center gap-5 xl:gap-7'>
              {/* DESKTOP NAVIGATION */}
              <nav
                ref={dropdownRef}
                className='hidden items-center gap-5 xl:gap-7 md:flex'
              >
                {navigation.map(item => {
                  // SERVICES DROPDOWN
                  if (item.name === 'Services') {
                    return (
                      <div key='services' className='relative py-4'>
                        <button
                          type='button'
                          onClick={() =>
                            setActiveDropdown(
                              activeDropdown === 'services' ? null : 'services'
                            )
                          }
                          aria-expanded={activeDropdown === 'services'}
                          className={`flex items-center gap-1.5 text-sm font-semibold transition-colors duration-200 ${
                            activeDropdown === 'services'
                              ? 'text-[#d32c30]'
                              : 'text-gray-700 hover:text-[#d32c30]'
                          }`}
                        >
                          Services
                          <ChevronDown
                            size={15}
                            className={`transition-transform duration-300 ${
                              activeDropdown === 'services' ? 'rotate-180' : ''
                            }`}
                          />
                        </button>

                        {/* SERVICES DROPDOWN */}
                        <div
                          className={`absolute left-0 top-full z-[100] w-80 pt-2 transition-all duration-200 ${
                            activeDropdown === 'services'
                              ? 'visible translate-y-0 opacity-100'
                              : 'invisible translate-y-2 opacity-0 pointer-events-none'
                          }`}
                        >
                          <div className='overflow-hidden rounded-xl border border-gray-100 bg-white p-2 shadow-[0_15px_45px_rgba(0,0,0,0.15)]'>
                            <div className='border-b border-gray-100 px-4 py-3'>
                              <p className='text-xs font-bold uppercase tracking-[2px] text-[#d32c30]'>
                                Our Services
                              </p>

                              <p className='mt-1 text-xs text-gray-400'>
                                Logistics solutions for your business
                              </p>
                            </div>

                            <div className='py-1'>
                              {services.map(service => (
                                <Link
                                  key={service.name}
                                  to={service.path}
                                  onClick={() => setActiveDropdown(null)}
                                  className='group/item flex items-center justify-between rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition-all duration-200 hover:bg-[#f8f8fc] hover:text-[#d32c30]'
                                >
                                  <span>{service.name}</span>

                                  <ArrowUpRight
                                    size={15}
                                    className='text-gray-300 transition-all group-hover/item:translate-x-1 group-hover/item:text-[#d32c30]'
                                  />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }

                  // JOIN US DROPDOWN
                  if (item.name === 'Join Us') {
                    return (
                      <div key='joinus' className='relative py-4'>
                        <button
                          type='button'
                          onClick={() =>
                            setActiveDropdown(
                              activeDropdown === 'joinus' ? null : 'joinus'
                            )
                          }
                          aria-expanded={activeDropdown === 'joinus'}
                          className={`flex items-center gap-1.5 text-sm font-semibold transition-colors duration-200 ${
                            activeDropdown === 'joinus'
                              ? 'text-[#d32c30]'
                              : 'text-gray-700 hover:text-[#d32c30]'
                          }`}
                        >
                          Join Us
                          <ChevronDown
                            size={15}
                            className={`transition-transform duration-300 ${
                              activeDropdown === 'joinus' ? 'rotate-180' : ''
                            }`}
                          />
                        </button>

                        {/* JOIN US DROPDOWN */}
                        <div
                          className={`absolute left-0 top-full z-[100] w-72 pt-2 transition-all duration-200 ${
                            activeDropdown === 'joinus'
                              ? 'visible translate-y-0 opacity-100'
                              : 'invisible translate-y-2 opacity-0 pointer-events-none'
                          }`}
                        >
                          <div className='overflow-hidden rounded-xl border border-gray-100 bg-white p-2 shadow-[0_15px_45px_rgba(0,0,0,0.15)]'>
                            <div className='border-b border-gray-100 px-4 py-3'>
                              <p className='text-xs font-bold uppercase tracking-[2px] text-[#d32c30]'>
                                Join Our Team
                              </p>

                              <p className='mt-1 text-xs text-gray-400'>
                                Grow your career with us
                              </p>
                            </div>

                            <div className='py-1'>
                              {join_us.map(option => (
                                <Link
                                  key={option.name}
                                  to={option.path}
                                  onClick={() => setActiveDropdown(null)}
                                  className='group/item flex items-center justify-between rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition-all duration-200 hover:bg-[#f8f8fc] hover:text-[#d32c30]'
                                >
                                  <span>{option.name}</span>

                                  <ArrowUpRight
                                    size={15}
                                    className='text-gray-300 transition-all group-hover/item:translate-x-1 group-hover/item:text-[#d32c30]'
                                  />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }

                  // NORMAL NAVIGATION LINKS
                  return (
                    <Link
                      key={item.name}
                      to={item.path}
                      className='whitespace-nowrap text-sm font-semibold text-gray-700 transition-colors duration-200 hover:text-[#d32c30]'
                    >
                      {item.name}
                    </Link>
                  )
                })}
              </nav>

              {/* DESKTOP ACTION BUTTONS */}
              <div className='hidden items-center gap-2 xl:flex'>
                <button
                  onClick={() => navigate('/get-a-quote')}
                  className='rounded-md bg-[#ffcb05] px-4 py-2.5 text-xs font-extrabold tracking-wide text-[#211f57] shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#211f57] hover:text-[#ffff] hover:shadow-md'
                >
                  GET A QUOTE
                </button>

                <button
                  onClick={() => navigate('/track-shipment')}
                  className='flex items-center gap-2 rounded-md bg-[#d32c30] px-4 py-2.5 text-xs font-extrabold tracking-wide text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#b91f25] hover:shadow-md'
                >
                  TRACK PACKAGE
                </button>
              </div>

              {/* MOBILE MENU BUTTON */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={mobileMenuOpen}
                className='flex h-10 w-10 items-center justify-center rounded-lg bg-gray-50 text-[#211f57] transition hover:bg-gray-100 md:hidden'
              >
                {mobileMenuOpen ? <X size={25} /> : <Menu size={25} />}
              </button>
            </div>
          </div>

          {/* MOBILE NAVIGATION */}
          <div
            className={`overflow-hidden border-t border-gray-100 bg-white transition-all duration-300 md:hidden ${
              mobileMenuOpen
                ? 'max-h-[85vh] overflow-y-auto opacity-100'
                : 'max-h-0 opacity-0'
            }`}
          >
            <div className='space-y-1 px-4 py-4 sm:px-6'>
              {navigation.map(item => {
                if (item.name === 'Services') {
                  return (
                    <div key='services-mobile'>
                      <button
                        onClick={() => setServicesDropdown(!servicesDropdown)}
                        aria-expanded={servicesDropdown}
                        className={`flex w-full items-center justify-between rounded-lg px-4 py-3 text-sm font-semibold transition ${
                          servicesDropdown
                            ? 'bg-[#f8f8fc] text-[#d32c30]'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        Services
                        <ChevronDown
                          size={17}
                          className={`transition-transform duration-300 ${
                            servicesDropdown ? 'rotate-180 text-[#d32c30]' : ''
                          }`}
                        />
                      </button>

                      {servicesDropdown && (
                        <div className='ml-3 mt-1 space-y-1 border-l-2 border-[#d32c30]/20 py-1 pl-3'>
                          {services.map(service => (
                            <Link
                              key={service.name}
                              to={service.path}
                              onClick={() => setMobileMenuOpen(false)}
                              className='flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-gray-600 transition hover:bg-red-50 hover:text-[#d32c30]'
                            >
                              {service.name}
                              <ChevronRight
                                size={15}
                                className='text-gray-300'
                              />
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                }

                if (item.name === 'Join Us') {
                  return (
                    <div key='joinus-mobile'>
                      <button
                        onClick={() => setJoinUsDropdown(!joinUsDropdown)}
                        aria-expanded={joinUsDropdown}
                        className={`flex w-full items-center justify-between rounded-lg px-4 py-3 text-sm font-semibold transition ${
                          joinUsDropdown
                            ? 'bg-[#f8f8fc] text-[#d32c30]'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        Join Us
                        <ChevronDown
                          size={17}
                          className={`transition-transform duration-300 ${
                            joinUsDropdown ? 'rotate-180 text-[#d32c30]' : ''
                          }`}
                        />
                      </button>

                      {joinUsDropdown && (
                        <div className='ml-3 mt-1 space-y-1 border-l-2 border-[#d32c30]/20 py-1 pl-3'>
                          {join_us.map(option => (
                            <Link
                              key={option.name}
                              to={option.path}
                              onClick={() => setMobileMenuOpen(false)}
                              className='flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-gray-600 transition hover:bg-red-50 hover:text-[#d32c30]'
                            >
                              {option.name}
                              <ChevronRight
                                size={15}
                                className='text-gray-300'
                              />
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                }

                return (
                  <Link
                    key={item.name}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className='block rounded-lg px-4 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 hover:text-[#d32c30]'
                  >
                    {item.name}
                  </Link>
                )
              })}

              {/* MOBILE ACTION BUTTONS */}
              <div className='grid grid-cols-2 gap-3 border-t border-gray-100 pt-4'>
                <button
                  onClick={() => {
                    setMobileMenuOpen(false)
                    navigate('/get-a-quote')
                  }}
                  className='flex items-center justify-center rounded-lg bg-[#fff44f] px-3 py-3 text-xs font-extrabold tracking-wide text-[#211f57] shadow-sm transition hover:bg-yellow-300'
                >
                  GET QUOTE
                </button>

                <button
                  onClick={() => {
                    setMobileMenuOpen(false)
                    navigate('/track-shipment')
                  }}
                  className='flex items-center justify-center gap-1.5 rounded-lg bg-[#d32c30] px-3 py-3 text-xs font-extrabold tracking-wide text-white shadow-sm transition hover:bg-red-700'
                >
                  TRACK PACKAGE
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* PREMIUM ANNOUNCEMENT MARQUEE */}
        <div className='relative z-40 bg-[#171644] text-white overflow-hidden border-y border-white/10 shadow-md'>
          <div className='flex items-center h-12 sm:h-14'>
            {/* MARQUEE CONTENT */}
            <div className='relative flex-1 overflow-hidden'>
              {/* SIDE FADE */}
              <div className='absolute left-0 top-0 z-[2] h-full w-8 bg-gradient-to-r from-[#171644] to-transparent pointer-events-none'></div>
              <div className='absolute right-0 top-0 z-[2] h-full w-8 bg-gradient-to-l from-[#171644] to-transparent pointer-events-none'></div>

              <div className='flex w-max whitespace-nowrap animate-marquee hover:[animation-play-state:paused]'>
                {[1, 2].map(item => (
                  <div
                    key={item}
                    className='flex items-center gap-6 sm:gap-10 px-5 sm:px-8 text-xs sm:text-sm font-medium'
                  >
                    <span className='text-white/90'>
                      Welcome to{' '}
                      <strong className='text-[#FFF44F]'>
                        S INFINITE EXPRESS
                      </strong>{' '}
                      – Your Trusted Logistics Partner.
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>

                    <span className='text-white/90'>
                      Reliable & Efficient Logistics Solutions Across India.
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>

                    <span className='text-white/90'>
                      Explore Our{' '}
                      <strong className='text-[#FFF44F]'>Cold Chain</strong>{' '}
                      Temperature-Controlled Services.
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>

                    <span className='text-white/90'>
                      Connecting Businesses Through Smart Supply Chain
                      Solutions.
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>

                    {/* SECURITY ANNOUNCEMENT */}
                    <span className='flex items-center gap-2 rounded-md bg-red-500/10 border border-red-400/30 px-3 py-1.5'>
                      <span className='text-red-400 font-black tracking-wider text-[10px] sm:text-xs'>
                        SECURITY ALERT
                      </span>

                      <span className='text-white/90'>
                        Please do not transfer money through payment links that
                        are not shared by official S Infinite Express accounts.
                      </span>
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>

                    <span className='flex items-center gap-2 rounded-md bg-red-500/10 border border-red-400/30 px-3 py-1.5'>
                      <span className='text-red-400 font-black tracking-wider text-[10px] sm:text-xs'>
                        CYBER SECURITY ALERT
                      </span>

                      <span className='text-white/90'>
                        Beware of fake S Infinite Express delivery SMS. Avoid
                        suspicious links and never share personal or payment
                        details on unofficial websites.
                      </span>
                    </span>

                    <span className='text-[#FFF44F]'>◆</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* BOTTOM ACCENT */}
          <div className='absolute bottom-0 left-0 w-full h-[1px] bg-white/10'></div>
        </div>
      </div>
    </>
  )
}
